module.exports = __webpack_public_path__ + "img/BT_gallery_UK.d07bb24e.svg";